






import Vue from "vue";

export default Vue.extend({
  name: "BaseInputColor",
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  methods: {
    onClick() {
      this.$refs.input.click();
    },
    updateSelf(value: string) {
      this.$emit("input", value);
    },
  },
});
